<template>
<div class="row">
    <div class="col-md-12">
        <div class="card p-3">
            <b-card>
                <b-card-title>
                    <b-row>
                        <h3 class="text-center">Pedido Mínimo</h3>
                    </b-row>
                </b-card-title>
                <b-card-body>
                    <b-button :disabled="perfil !== 'adm'" class="mb-2" variant="success" size="sm" @click="adicionarClasse" >Adicionar Classe</b-button>
                    <table class="table table-bordered table-striped text-center">
                        <thead>
                            <tr>
                                <th class="text-center">Classe</th>
                                <th class="text-center">Restrição em</th>
                                <th class="text-center">Valor Mínimo</th>
                                <th class="text-center">Qtd. Pedidos Mínimo</th>
                                <th class="text-center">Qtd. Mínima de itens</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for='restricao in restricoes' :key="restricao.classe">
                                <td>{{ (restricao.classe == 'U')? 'Não Listada' : restricao.classe}}</td>
                                <td>{{formatarLabelRestricao(restricao.restricao)}}</td>
                                <td>{{ (restricao.restricao === 'VALOR')? "R$ " + restricao.valor +",00" : restricao.valor}}</td>
                                <td>{{ restricao.quantidade_pedido}}</td>
                                <td>{{ restricao.itens }}</td>
                                <td>
                                    <b-button variant="primary" title="Editar Regra" size="sm" @click.prevent="showModal(restricao.id)"><i class="fa fa-edit"></i></b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card-body>
                <blockquote class="blockquote">
                    <p class="mb-0">Quando não houver um valor mínimo para a Classe do Distribuidor, o valor "Não Listada" será utilizado.</p>
                </blockquote>
            </b-card>
            <!-- <b-card class="mt-2">
                <h4 style="text-align: center;">Exceções de Pedido Mínimo</h4>
                <b-row>
                    <b-col lg="6" class="my-1">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Buscar Exceção"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" class="my-1">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-button variant="primary" style="position: absolute; right: 0;" size="sm" @click="addRegra">Adicionar Exceção</b-button>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-table :items="dataTable" :fields="fields" :current-page="currentPage" :per-page="perPage" stacked="md" hover show-empty small :filter="filter">
                    <template #cell(deletar)="row">
                        <b-button variant="danger" @click="deletarRegra(row.item.id)"><i class="fas fa-trash"></i></b-button>
                    </template>
                </b-table>
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
            </b-card> -->
            <!-- <table class="table table-bordered table-striped text-center">
                <thead>
                    <tr colspan="2">
                        <b-button variant="primary" size="sm" @click="addRegra">Adicionar Exceção</b-button>
                    </tr>
                    <tr>
                        <th>Distribuidor</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="d in listaRegras" :key="d.id">
                        <td>{{ d.distribuidor.nome }}</td>
                        <td><b-button variant="danger" @click.prevent="deletarRegra(d.id)"><i class="fas fa-trash"></i></b-button></td>
                    </tr>
                </tbody>
            </table> -->
        </div>
    </div>

    <!---------------------------------- Modal -------------------- -->
    <b-modal v-model="openedModal" size="xl">
        <b-card>
            <b-card-title>
                <b-row>
                    <b-col sm="3">
                        <label for="class">Classe:</label>
                        <b-form-input :disabled='!novaClasse' id="class" placeholder="Informe a Classe" :v-mask="'SS'" v-model="classe"></b-form-input>
                    </b-col>
                </b-row>
            </b-card-title>
            <b-card-body>
                <b-row>
                    <div class="form-group col-md-6">
                        <label for="">Parâmetro para Valor Mínimo</label>
                    </div>
                    <div class="form-group col-md-6">
                        <select name="" id="" class="form-control" v-model="tipo">
                            <option value="ITEM"> Quantidade de Ítens</option>
                            <option value="PRODUTO"> Quantidade de Produtos</option>
                            <option value="VALOR">Valor em Reais (R$)</option>
                        </select>
                    </div>
                </b-row>
                <b-row>
                    <div class="form-group col-md-6">
                        <label for="">Limite Mínimo:</label>
                    </div>
                    <div class="form-group col-md-6">
                        <input type="text" class="form-control" v-mask="'######'" v-model="valor">
                    </div>
                </b-row>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="">Quantidade mínima de Pedidos :</label>
                    </div>
                    <div class="form-group col-md-6">
                        <input type="text" class="form-control" v-mask="'##'" v-model="quantidade">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="">Quantidade mínima de Itens :</label>

                    </div>

                    <div class="form-group col-md-6">
                        <input type="text" class="form-control" v-mask="'####'" v-model="itens">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="">Data de Fechamento :</label>

                    </div>

                    <div class="form-group col-md-6">
                        <date-picker v-model="data_fechamento" :config="datePickerConfig"></date-picker>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="">Data de Fechamento <small>(Centro Distribuição)</small> :</label>

                    </div>

                    <div class="form-group col-md-6">
                        <date-picker v-model="data_fechamento_cd" :config="datePickerConfig"></date-picker>
                    </div>
                </div>
            </b-card-body>
        </b-card>
        <template #modal-footer>
            <b-button variant="primary" size="sm" class="float-right mr-2" @click.prevent="update">Salvar</b-button>
            <b-button variant="danger" size="sm" class="float-right mr-2" @click="openedModal = false">Cancelar</b-button>
        </template>
    </b-modal>

    <b-modal v-model="openedRules" title="Exceção a regra do pedido Mínimo" size="xl">
        <b-card>
            <b-card-body>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Digite o nome e selecione</label>
                            <v-select v-model="distribuidor" :options="distribuidores" :onSearch="loadDistribuidor"></v-select>
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-card>
        <template #modal-footer>
            <b-button variant="primary" size="sm" class="float-right mr-3" @click="saveRegra">Salvar</b-button>
            <b-button variant="danger" size="sm" class="float-right mr-3" @click="openedRules = false">Cancelar</b-button>
        </template>

    </b-modal>
</div>
</template>

<script>
export default {

    data() {

        return {
            restricoes: [],
            currentId: 0,
            perfil: null,
            tipo: "",
            classe: '',
            listaClasse: [],
            valor: 0,
            labelClasse: "",
            quantidade: 0,
            itens: 0,
            distribuidores: [],
            distribuidor: '',
            listaRegras: [],
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true
            },
            data_fechamento: '',
            data_fechamento_cd: '',
            openedModal: false,
            openedRules: false,
            fields: [{
                    label: 'Distribuidor',
                    key: 'distribuidor',
                    class: "text-center",
                    formatter: (value) => {
                        return value.nome ? value.nome : ""
                    }
                },
                {
                    label: '',
                    key: 'deletar',
                    class: "text-center"
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            filter: null,
            novaClasse: false,
        }
    },
    methods: {
        getPerfil(){
            const vm = this;
            axios
            .get("/my-profile")
            .then((response) => {
                vm.perfil = response.data.profile.roles[0].name;
            })
            .catch((erro) => {
                console.log(erro);
                alert(erro);
            })
        },
        adicionarClasse() {
            const vm = this;
            vm.novaClasse = true;
            vm.clearForm();
            vm.currentId = 0;
            vm.openedModal = true;
        },
        loadRestricoes() {
            var vm = this;
            $('.loading').show();
            axios.get('/adm/pedidominimo').then(function (response) {
                vm.restricoes = response.data;
                $('.loading').hide();
            }).catch(function (error) {
                alert("Falha ao carregar as restrições");
                console.log(error);
                $('.loading').hide();
            });
        },

        showModal(id) {
            var vm = this;
            var idRestricao = id;
            vm.novaClasse = false;
            vm.restricoes.forEach(function (item) {
                if (item.id === idRestricao) {
                    vm.labelClasse = (item.classe === 'U') ? "Classe Não listada" : "Classe " + item.classe;
                    vm.classe = item.classe;
                    vm.currentId = item.id;
                    vm.tipo = item.restricao;
                    vm.valor = item.valor;
                    vm.quantidade = item.quantidade_pedido;
                    vm.itens = item.itens;
                    vm.data_fechamento = moment(item.data_fechamento).format('DD/MM/YYYY');
                    vm.data_fechamento_cd = moment(item.data_fechamento_cd).format('DD/MM/YYYY');
                    vm.openedModal = true;
                    return;
                }
            });
        },

        update() {
            var vm = this;
            if (parseInt(this.valor) < 0) {
                alert('O Valor Mínimo deve ser maior ou igual a 0!');
                return;
            }
            let dtfecha = this.data_fechamento;
            let dtfechacd = this.data_fechamento_cd;
            let data = {
                novaClasse : this.novaClasse,
                classe : this.classe,
                restricao: this.tipo,
                valor: this.valor,
                quantidade: this.quantidade,
                itens: this.itens,
                data_fechamento: dtfecha.split('/').reverse().join('-'),
                data_fechamento_cd: dtfechacd.split('/').reverse().join('-'),
                _method: "PUT"
            };
            $('.loading').show();
            axios.post('/adm/pedidominimo/' + this.currentId, data)
            .then((response) => {
                vm.clearForm();
                vm.openedModal = false;
                vm.loadRestricoes();
                $('.loading').hide();
                vm.$swal('OK', response.data.success, 'success')
            }).catch((error) => {
                $('.loading').hide(); 
                console.log(error.response.data.errors)         
                vm.$swal({
                    title:'Error', 
                    text: error.response.data.errors, 
                    icon:'error'
                    });
            });
        },

        formatarLabelRestricao(restricao) {
            switch (restricao) {
                case "ITEM":
                    return "Número mínimo de Ítens";
                case 'VALOR':
                    return "Valor em R$";
                case 'PRODUTO':
                    return "Número mínimo de Produtos";
            }
        },

        clearForm() {
            this.currentId = 0;
            this.tipo = "";
            this.classe = "";
            this.valor = 0;
            this.itens = 0;
            this.quantidade = 0;
            this.data_fechamento = '';
            this.data_fechamento_cd = '';
        },

        addRegra() {
            this.openedRules = true;
        },

        saveRegra() {
            if (this.distribuidor === '') {
                return this.$swal('Atenção', 'Informe um Distribuidor.', 'error');
            }
            var vm = this;
            axios.post('/adm/pedidominimo/regra/save', {
                distribuidor: vm.distribuidor.value
            }).then(function (response) {
                vm.openedRules = false;
                vm.getRegras();
            })
        },

        getRegras() {
            this.listaRegras = []
            var vm = this
            axios.get('/adm/pedidominimo/regras').then(function (response) {
                vm.listaRegras = response.data
                vm.totalRows = vm.listaRegras.length
            }).catch(function (error) {
                console.log(error)
            });
        },

        loadDistribuidor(key) {
            var vm = this;
            this.distribuidores = [];
            axios.get('/adm/distribuidores/combo', {
                params: {
                    query: key
                }
            }).then(function (response) {
                console.log(response.data);
                var obj = response.data;
                obj.forEach(function (v) {
                    vm.distribuidores.push({
                        value: v.id,
                        label: v.codigo + ' - ' + v.nome
                    });
                });
            }).catch(function (error) {
                console.log(error);
            });
        },

        deletarRegra(id) {
            var vm = this;
            vm.$swal.fire({
                title: 'Realmente deseja deletar esta exceção ?',
                text: "Esta ação não poderá ser revertida!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim Deletar!',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                $('.loading').show();
                if (result.value) {
                    axios.post('/adm/pedidominimo/regra/delete', {
                        id: id
                    }).then(function (response) {
                        $('.loading').hide();
                        vm.$swal('Ok!', response.data.success, 'success');
                        vm.getRegras();
                    }).catch(function (error) {
                        $('.loading').hide();
                        var e = error.response.data.errors;
                        vm.$swal('Ok', error.response ? e : `${error}`, 'error');
                    });

                } else {
                    $('.loading').hide();
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
    },

    computed: {
        dataTable() {
            var vm = this
            var data = vm.listaRegras;
            return data;
        }
    },

    created() {
        this.getPerfil();
        this.loadRestricoes();
        // this.getRegras();
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pedido_minimo/Main.vue